import type { ReactNode } from 'react';
import { Drawer } from '../primitives/Dialog';

/**
 * ConfigurationDrawer holds configuration that used to sit permanently on
 * the page: a right-hand panel opened by the action that needs it, closed
 * by Escape, the backdrop or its own button. It is the shared `Drawer`
 * (CO-88) under the name its call sites already use.
 */
export function ConfigurationDrawer({
  open,
  title,
  description,
  onClose,
  children,
  footer,
  testId,
  size = 'default',
}: {
  open: boolean;
  title: string;
  description?: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  testId?: string;
  /** 'wide' for content shaped like a table. */
  size?: 'default' | 'wide';
}) {
  return (
    <Drawer open={open} title={title} description={description} onClose={onClose} footer={footer} testId={testId} size={size}>
      {children}
    </Drawer>
  );
}
